import React, { useState } from 'react';
import Button from '../../@redantler/redantler-npm-button-react';
import './CartQuantity.scss';
import Loader from '../../UI/Icons/Loader/Loader';

const CartQuantity = ({ handleIncrementClick, handleDecrementClick, counter }) => {
  const [fetching, setFetching] = useState(false);

  const incrementAction = async () => {
    setFetching(true);
    await handleIncrementClick()
      .then(() => setFetching(false))
      .catch(() => {
        setFetching(false);
        console.error('Error fetching, please try again');
      });
  };

  const decrementAction = async () => {
    setFetching(true);
    await handleDecrementClick()
      .then(() => setFetching(false))
      .catch(() => {
        setFetching(false);
        console.error('Error fetching, please try again');
      });
  };

  return (
    <div className="c-cart-quantity background-color-gray">
      <Button onClick={decrementAction}>-</Button>
      <span className="c-cart-quantity__amount">{fetching ? <Loader /> : counter}</span>
      <Button onClick={incrementAction}>+</Button>
    </div>
  );
};

export default CartQuantity;
